const devMode = process.env.NODE_ENV === 'development';

const config = {
  APP_NAME: 'Amélia e Rodrigo',
  APP_DESCRIPTION: '',
  DEV: devMode,
  TIMEOUT: 10000,
  CHECK_CONNECTION_INTERVAL: 5000,
  PING_SERVER_URL: process.env.REACT_APP_API_URL,
  GOOGLE_ANALYTICS_TRACKING_ID: ''
};

export default config;



// WEBPACK FOOTER //
// ./src/constants/config.js